import RMSActionCenterContainer from "./RMSActionCenterContainer";
import RMSActionCenterStore from "./RMSActionCenterStore";

export default RMSActionCenterStore(RMSActionCenterContainer);